// src/docs/DocsKycUpdates.js
import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

const DocsKycUpdates = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        Updating KYC & Verification Details
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        Keeping your KYC and verification details up-to-date is essential for maintaining your project's credibility and ensuring a smooth experience on CrowdLaunch. This guide explains why updating your details is important, how to do it, and what to expect from the approval process.
      </Typography>

      {/* Why Update Your KYC Details */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why Update Your KYC Details?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        Updated KYC information enhances trust and transparency with potential investors and the CrowdLaunch community. Keeping your details current helps ensure that your project remains compliant, visible, and accurately represented in our verified projects section.
      </Typography>

      {/* How to Update Your Details */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How to Update Your KYC & Verification Details
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        To update your KYC details, navigate to Manage and select the project you wish to modify. Click the "Edit" icon next to the field (e.g., website URL, social media handles) you want to change. Enter your new information in the provided form and submit your request. Your update will then be reviewed by our team, and it will appear as pending until it is approved.
      </Typography>

      {/* Security & Approval Process */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Security & Approval Process
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 3 }}>
        For security reasons, any changes to your KYC details must be verified and approved by our administrators. This helps prevent fraudulent updates and maintains the integrity of project information on CrowdLaunch.
      </Typography>

     

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By keeping your KYC and verification details current, you enhance the trustworthiness of your project and ensure it continues to be showcased properly on CrowdLaunch. Follow these steps to update your information and monitor your submission status via your profile dashboard.
      </Typography>
    </Container>
  );
};

export default DocsKycUpdates;
